<template>

  <div class="page-root">



    <!-- ─── TOOLBAR ───────────────────────────────────────────── -->

    <v-toolbar dense tabs color="primary darken-2" dark class="page_title">

      <v-toolbar-title class="pa-0 pr-0 mt-1">

        <v-layout row>

          <v-flex xs10 sm11 text-xs-left>

            <a href="javascript: history.go(-1)" class="pa-0">

              <v-btn flat fab small class="pa-0">

                <i class="fas fa-arrow-left headline"></i>

              </v-btn>

            </a>

            Investment Group

          </v-flex>

          <v-flex xs2 sm1 text-xs-right>

            <router-link :to="'/savings'" class="pa-0 text-xs-right">

              <v-btn flat fab small class="pa-0">

                <i class="fas fa-close headline"></i>

              </v-btn>

            </router-link>

          </v-flex>

        </v-layout>

      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-tabs

        v-model="tabs"

        color="transparent"

        slider-color="white"

        slot="extension"

        grow

      >

        <v-tab v-for="tabsItem in tabsItems" :key="tabsItem.id" :to="tabsItem.link">

          {{ tabsItem.title }}

        </v-tab>

      </v-tabs>

    </v-toolbar>



    <!-- ─── LOADING ───────────────────────────────────────────── -->

    <div v-if="hasActiveInvestment === null" class="state-screen">

      <div class="loader-ring">

        <div></div><div></div><div></div><div></div>

      </div>

      <p class="loader-label">Verifying access…</p>

    </div>



    <!-- ─── NO ACCESS ─────────────────────────────────────────── -->

    <div v-else-if="hasActiveInvestment === false" class="state-screen no-access-bg">

      <div class="gate-card">

        <div class="gate-icon-wrap">

          <div class="gate-pulse"></div>

          <v-icon size="52" color="white">fas fa-lock</v-icon>

        </div>



        <div class="gate-eyebrow">Members-Only</div>



        <h1 class="gate-title">

          This page is for<br>active investors

        </h1>



        <p class="gate-body">

          The Community Investors dashboard is available exclusively to members

          who have an active investment with at least one validated payment.

          Once your first payment is confirmed, you'll have full access.

        </p>



        <div class="gate-divider"></div>



        <div class="gate-pitch">

          <div class="pitch-badge">

            <v-icon size="16" color="teal darken-1">fas fa-percentage</v-icon>

            <span>18% fixed annual return</span>

          </div>

          <div class="pitch-badge">

            <v-icon size="16" color="teal darken-1">fas fa-shield-alt</v-icon>

            <span>Registered fintech company</span>

          </div>

          <div class="pitch-badge">

            <v-icon size="16" color="teal darken-1">fas fa-calendar-alt</v-icon>

            <span>12-month term, from 250 000 FCFA</span>

          </div>

        </div>



        <div class="gate-actions">

          <v-btn

            large

            color="teal darken-2"

            class="white--text gate-btn-primary"

            :to="{ name: 'investments.create' }"

          >

            <v-icon left>fas fa-chart-line</v-icon>

            Start Investing

          </v-btn>

          <v-btn

            large

            outline

            color="teal darken-2"

            class="gate-btn-ghost"

            :to="{ name: 'savings.home' }"

          >

            <v-icon left>fas fa-arrow-left</v-icon>

            My Savings

          </v-btn>

        </div>

      </div>

    </div>



    <!-- ─── FULL PAGE ─────────────────────────────────────────── -->

    <div v-else class="investors-overview-container">



      <!-- Hero Header -->

      <div class="hero-header mb-4">

        <div class="hero-glow"></div>

        <v-layout row wrap align-center class="hero-inner">

          <v-flex xs12 md7>

            <div class="hero-eyebrow">

              <span class="eyebrow-dot"></span>

              Live Community Data

            </div>

            <h1 class="hero-title">Community<br>Investors</h1>

            <p class="hero-sub">Track every member's investment progress in real time.</p>

          </v-flex>

          <v-flex xs12 md5 class="mt-3 mt-md-0">

            <div class="hero-kpi-row">

              <div class="hero-kpi">

                <span class="kpi-number">{{ totalInvestors }}</span>

                <span class="kpi-label">Active<br>Investors</span>

              </div>

              <div class="hero-kpi-sep"></div>

              <div class="hero-kpi">

                <span class="kpi-number">{{ globalStats.avg_progress }}%</span>

                <span class="kpi-label">Average<br>Progress</span>

              </div>

              <div class="hero-kpi-sep"></div>

              <div class="hero-kpi">

                <span class="kpi-number">18%</span>

                <span class="kpi-label">Annual<br>Return</span>

              </div>

            </div>

          </v-flex>

        </v-layout>

      </div>



      <!-- Statistics Dashboard -->

      <v-card class="elevation-6 mb-4" style="border-radius: 16px;">

        <v-card-text class="pa-4">

          <div class="section-label mb-4">

            <v-icon small color="teal darken-2" class="mr-1">fas fa-chart-bar</v-icon>

            Community Statistics

          </div>



          <v-layout row wrap>

            <!-- Payment Type Distribution -->

            <v-flex xs12 md6 class="pr-md-3 mb-4 mb-md-0">

              <h4 class="chart-title mb-3">Payment Type Distribution</h4>



              <div class="mb-3">

                <div class="dist-meta mb-1">

                  <v-icon x-small color="purple darken-2" class="mr-1">fas fa-calendar-alt</v-icon>

                  <span class="dist-name">Monthly</span>

                  <span class="dist-count">{{ paymentTypeStats.monthly_count }}</span>

                </div>

                <div class="dist-track">

                  <div class="dist-fill monthly-fill" :style="{ width: paymentTypeStats.monthly_percentage + '%' }">

                    <span class="dist-pct">{{ paymentTypeStats.monthly_percentage }}%</span>

                  </div>

                </div>

              </div>



              <div>

                <div class="dist-meta mb-1">

                  <v-icon x-small color="green darken-2" class="mr-1">fas fa-hand-holding-usd</v-icon>

                  <span class="dist-name">One-Time</span>

                  <span class="dist-count">{{ paymentTypeStats.onetime_count }}</span>

                </div>

                <div class="dist-track">

                  <div class="dist-fill onetime-fill" :style="{ width: paymentTypeStats.onetime_percentage + '%' }">

                    <span class="dist-pct">{{ paymentTypeStats.onetime_percentage }}%</span>

                  </div>

                </div>

              </div>

            </v-flex>



            <!-- Progress Distribution -->

            <v-flex xs12 md6 class="pl-md-3">

              <h4 class="chart-title mb-3">Progress Distribution</h4>



              <div class="mb-3">

                <div class="dist-meta mb-1">

                  <span class="prog-range high-range">80–100%</span>

                </div>

                <v-progress-linear

                  :value="totalInvestors ? (progressStats.high / totalInvestors) * 100 : 0"

                  height="28"

                  color="green darken-1"

                >

                  <strong class="white--text">{{ progressStats.high }} investors</strong>

                </v-progress-linear>

              </div>



              <div class="mb-3">

                <div class="dist-meta mb-1">

                  <span class="prog-range mid-range">50–79%</span>

                </div>

                <v-progress-linear

                  :value="totalInvestors ? (progressStats.medium / totalInvestors) * 100 : 0"

                  height="28"

                  color="orange darken-1"

                >

                  <strong class="white--text">{{ progressStats.medium }} investors</strong>

                </v-progress-linear>

              </div>



              <div>

                <div class="dist-meta mb-1">

                  <span class="prog-range low-range">0–49%</span>

                </div>

                <v-progress-linear

                  :value="totalInvestors ? (progressStats.low / totalInvestors) * 100 : 0"

                  height="28"

                  color="red darken-1"

                >

                  <strong class="white--text">{{ progressStats.low }} investors</strong>

                </v-progress-linear>

              </div>

            </v-flex>

          </v-layout>



          <v-divider class="my-4"></v-divider>



          <!-- Community Average -->

          <div class="section-label mb-2">Community Average Progress</div>

          <v-progress-linear

            :value="globalStats.avg_progress"

            height="36"

            color="teal darken-2"

            striped

          >

            <strong class="white--text title">{{ globalStats.avg_progress }}%</strong>

          </v-progress-linear>

        </v-card-text>

      </v-card>



      <!-- Filters Bar -->

      <v-card class="elevation-3 mb-3" style="border-radius: 14px;">

        <v-card-text class="pa-3">

          <v-layout row wrap align-center>

            <v-flex xs12 sm5 md4 class="pa-1">

              <v-text-field

                v-model="searchQuery"

                prepend-icon="fas fa-search"

                label="Search by name or username"

                clearable

                solo

                hide-details

              ></v-text-field>

            </v-flex>

            <v-flex xs12 sm4 md3 class="pa-1">

              <v-select

                v-model="filterPaymentType"

                :items="paymentTypeOptions"

                label="Payment Type"

                solo

                hide-details

                prepend-icon="fas fa-filter"

              ></v-select>

            </v-flex>

            <v-flex xs12 sm3 md3 class="pa-1">

              <v-select

                v-model="sortBy"

                :items="sortOptions"

                label="Sort by"

                solo

                hide-details

                prepend-icon="fas fa-sort"

              ></v-select>

            </v-flex>

            <v-flex xs12 md2 class="pa-1">

              <v-btn

                block

                large

                color="teal darken-2"

                class="white--text"

                @click="loadInvestors()"

                :loading="isLoading"

                style="border-radius: 10px;"

              >

                <v-icon left small>fas fa-sync-alt</v-icon>

                Refresh

              </v-btn>

            </v-flex>

          </v-layout>

        </v-card-text>

      </v-card>



      <!-- Result count -->

      <div class="result-meta mb-3" v-if="!isLoading">

        Showing <strong>{{ filteredInvestors.length }}</strong> of <strong>{{ totalInvestors }}</strong> investors

      </div>



      <!-- ─── INVESTOR CARDS ──────────────────────────────────── -->

      <div v-if="!isLoading">

        <div

          v-for="investor in filteredInvestors"

          :key="investor.investment_id"

          class="mb-3"

        >

          <v-card class="investor-card elevation-4" style="border-radius: 14px; overflow: hidden;">

            <!-- Accent bar -->

            <div class="accent-bar" :class="getAccentClass(investor.progress_percentage)"></div>



            <v-card-text class="pa-4" style="padding-left: 20px !important;">

              <v-layout row wrap align-center>



                <!-- Avatar + Info -->

                <v-flex xs12 sm4 md3>

                  <v-layout row align-center>

                    <div class="avatar-ring mr-3" :class="getAvatarRingClass(investor.username)">

                      <v-avatar size="52" :color="getAvatarColor(investor.username)" class="white--text">

                        <span class="title">{{ getInitials(investor.username) }}</span>

                      </v-avatar>

                    </div>

                    <div>

                      <div class="investor-name">{{ investor.full_name || investor.username }}</div>

                      <div class="investor-handle mb-1">@{{ investor.username }}</div>

                      <v-chip

                        x-small

                        :color="getPaymentTypeColor(investor.payment_type)"

                        dark

                      >

                        <v-icon x-small left>{{ getPaymentTypeIcon(investor.payment_type) }}</v-icon>

                        {{ investor.payment_type === 'monthly' ? 'Monthly' : 'One-Time' }}

                      </v-chip>

                    </div>

                  </v-layout>

                </v-flex>



                <!-- Stats -->

                <v-flex xs12 sm5 md6 class="mt-3 mt-sm-0">

                  <v-layout row wrap>

                    <v-flex xs6 sm4 class="pa-1">

                      <div class="stat-pill">

                        <span class="stat-pill-label">Investment</span>

                        <span class="stat-pill-value">{{ formatAmount(investor.investment_amount) }} <small>FCFA</small></span>

                      </div>

                    </v-flex>

                    <v-flex xs6 sm4 class="pa-1">

                      <div class="stat-pill">

                        <span class="stat-pill-label">Total Paid</span>

                        <span class="stat-pill-value green--text text--darken-2">{{ formatAmount(investor.total_paid) }} <small>FCFA</small></span>

                      </div>

                    </v-flex>

                    <v-flex xs6 sm4 class="pa-1">

                      <div class="stat-pill">

                        <span class="stat-pill-label">Interest</span>

                        <span class="stat-pill-value purple--text text--darken-2">{{ formatAmount(investor.interest_earned) }} <small>FCFA</small></span>

                      </div>

                    </v-flex>

                    <v-flex xs6 sm4 class="pa-1" v-if="investor.payment_type === 'monthly'">

                      <div class="stat-pill">

                        <span class="stat-pill-label">Months Done</span>

                        <span class="stat-pill-value teal--text text--darken-2">{{ investor.completed_payments }}<small>/10</small></span>

                      </div>

                    </v-flex>

                    <v-flex xs6 sm4 class="pa-1">

                      <div class="stat-pill">

                        <span class="stat-pill-label">End Date</span>

                        <span class="stat-pill-value">{{ formatDate(investor.end_date) }}</span>

                      </div>

                    </v-flex>

                  </v-layout>

                </v-flex>



                <!-- Progress circle + button -->

                <v-flex xs12 sm3 md3 class="text-xs-center mt-3 mt-sm-0">

                  <v-progress-circular

                    :value="investor.progress_percentage"

                    :size="88"

                    :width="8"

                    :color="getProgressColor(investor.progress_percentage)"

                    class="mb-2"

                  >

                    <span class="body-2 font-weight-bold">{{ investor.progress_percentage }}%</span>

                  </v-progress-circular>

                  <v-btn

                    small

                    color="teal darken-2"

                    class="white--text"

                    @click="openDetailsDialog(investor)"

                    block

                    style="border-radius: 8px;"

                  >

                    <v-icon small left>fas fa-eye</v-icon>

                    Details

                  </v-btn>

                </v-flex>

              </v-layout>



              <!-- Monthly Payment Timeline -->

              <div v-if="investor.payment_type === 'monthly' && investor.payments && investor.payments.length > 0">

                <v-divider class="mt-3 mb-2"></v-divider>

                <p class="caption grey--text mb-2">

                  <v-icon x-small class="mr-1">fas fa-calendar-check</v-icon>

                  Payment Timeline — validated only

                </p>

                <div style="display: flex; flex-wrap: wrap; gap: 6px;">

                  <v-tooltip top v-for="payment in investor.payments" :key="payment.month_number">

                    <template v-slot:activator="{ on }">

                      <v-chip

                        x-small

                        :color="getPaymentStatusColor(payment.status)"

                        dark

                        v-on="on"

                      >

                        <v-icon x-small left>{{ getPaymentStatusIcon(payment.status) }}</v-icon>

                        M{{ payment.month_number }}

                      </v-chip>

                    </template>

                    <span>

                      Month {{ payment.month_number }}<br>

                      {{ getPaymentStatusLabel(payment.status) }}<br>

                      {{ formatAmount(payment.amount_paid) }} FCFA<br>

                      {{ formatDate(payment.payment_date) }}

                    </span>

                  </v-tooltip>

                </div>

              </div>



              <!-- One-time badge -->

              <div v-if="investor.payment_type === 'one_time'">

                <v-divider class="mt-3 mb-2"></v-divider>

                <v-chip

                  small

                  :color="investor.one_time_payment_made ? 'green' : 'orange'"

                  dark

                >

                  <v-icon small left>{{ investor.one_time_payment_made ? 'fas fa-check-circle' : 'fas fa-clock' }}</v-icon>

                  One-Time Payment: {{ investor.one_time_payment_made ? 'Completed' : 'Pending' }}

                </v-chip>

              </div>

            </v-card-text>

          </v-card>

        </div>

      </div>



      <!-- Skeleton loader -->

      <div v-if="isLoading">

        <div v-for="i in 3" :key="i" class="skeleton-card mb-3"></div>

      </div>



      <!-- Empty State -->

      <v-card

        v-if="filteredInvestors.length === 0 && !isLoading"

        class="elevation-3 pa-5 text-xs-center"

        style="border-radius: 14px;"

      >

        <v-icon size="72" color="grey lighten-2">fas fa-users-slash</v-icon>

        <h3 class="title grey--text text--darken-1 mt-3 mb-2">No investors found</h3>

        <p class="body-2 grey--text">Try adjusting your filters or search query.</p>

        <v-btn flat color="teal darken-2" @click="searchQuery = ''; filterPaymentType = 'all'">

          <v-icon left small>fas fa-times</v-icon>

          Clear Filters

        </v-btn>

      </v-card>



    </div><!-- /full page -->



    <!-- ─── DETAILS DIALOG ─────────────────────────────────────── -->

    <v-dialog v-model="detailsDialog" max-width="860" scrollable>

      <v-card v-if="selectedInvestor" style="border-radius: 20px; overflow: hidden;">



        <!-- Dialog Header -->

        <div :class="['dialog-hero', selectedInvestor.payment_type === 'monthly' ? 'dialog-hero--purple' : 'dialog-hero--green']">

          <v-layout row wrap align-center class="pa-4">

            <v-flex xs8>

              <v-layout row align-center>

                <v-avatar size="56" :color="getAvatarColor(selectedInvestor.username)" class="white--text mr-3 elevation-4">

                  <span class="headline">{{ getInitials(selectedInvestor.username) }}</span>

                </v-avatar>

                <div>

                  <div class="white--text title font-weight-bold">

                    {{ selectedInvestor.full_name || selectedInvestor.username }}

                  </div>

                  <div class="white--text caption" style="opacity:.7;">@{{ selectedInvestor.username }}</div>

                  <v-chip x-small color="white" :text-color="selectedInvestor.payment_type === 'monthly' ? 'purple darken-2' : 'green darken-2'" class="mt-1">

                    {{ selectedInvestor.payment_type === 'monthly' ? 'Monthly Payments' : 'One-Time Payment' }}

                  </v-chip>

                </div>

              </v-layout>

            </v-flex>

            <v-flex xs4 class="text-xs-right">

              <v-btn icon dark @click="detailsDialog = false">

                <v-icon>fas fa-times</v-icon>

              </v-btn>

            </v-flex>

          </v-layout>

        </div>



        <v-card-text class="pa-4" style="max-height: 560px;">



          <!-- Key Numbers -->

          <v-layout row wrap class="mb-4">

            <v-flex xs12 sm4 class="pa-2">

              <div class="dialog-kpi teal-kpi">

                <v-icon size="28" color="teal darken-2" class="mb-1">fas fa-money-bill-wave</v-icon>

                <p class="caption grey--text mb-1">Investment Amount</p>

                <p class="title teal--text text--darken-2 font-weight-bold mb-0">

                  {{ formatAmount(selectedInvestor.investment_amount) }} FCFA

                </p>

              </div>

            </v-flex>

            <v-flex xs12 sm4 class="pa-2">

              <div class="dialog-kpi green-kpi">

                <v-icon size="28" color="green darken-2" class="mb-1">fas fa-coins</v-icon>

                <p class="caption grey--text mb-1">Total Paid</p>

                <p class="title green--text text--darken-2 font-weight-bold mb-0">

                  {{ formatAmount(selectedInvestor.total_paid) }} FCFA

                </p>

              </div>

            </v-flex>

            <v-flex xs12 sm4 class="pa-2">

              <div class="dialog-kpi purple-kpi">

                <v-icon size="28" color="purple darken-2" class="mb-1">fas fa-percentage</v-icon>

                <p class="caption grey--text mb-1">Interest Earned</p>

                <p class="title purple--text text--darken-2 font-weight-bold mb-0">

                  {{ formatAmount(selectedInvestor.interest_earned) }} FCFA

                </p>

              </div>

            </v-flex>

          </v-layout>



          <!-- Progress + Dates -->

          <v-layout row wrap align-center class="mb-4">

            <v-flex xs12 sm6 class="pa-2 text-xs-center">

              <v-progress-circular

                :value="selectedInvestor.progress_percentage"

                :size="130"

                :width="12"

                :color="getProgressColor(selectedInvestor.progress_percentage)"

              >

                <div class="text-xs-center">

                  <div class="display-1 font-weight-bold">{{ selectedInvestor.progress_percentage }}%</div>

                  <div class="caption grey--text">Progress</div>

                </div>

              </v-progress-circular>

            </v-flex>

            <v-flex xs12 sm6 class="pa-2">

              <v-layout row align-center class="mb-2">

                <v-icon small color="blue darken-2" class="mr-2">fas fa-calendar-plus</v-icon>

                <div>

                  <p class="caption grey--text mb-0">Start Date</p>

                  <p class="body-2 font-weight-bold mb-0">{{ formatDate(selectedInvestor.start_date) }}</p>

                </div>

              </v-layout>

              <v-divider class="my-2"></v-divider>

              <v-layout row align-center class="mb-2">

                <v-icon small color="orange darken-2" class="mr-2">fas fa-calendar-check</v-icon>

                <div>

                  <p class="caption grey--text mb-0">End Date</p>

                  <p class="body-2 font-weight-bold mb-0">{{ formatDate(selectedInvestor.end_date) }}</p>

                </div>

              </v-layout>

              <v-divider class="my-2" v-if="selectedInvestor.payment_type === 'monthly'"></v-divider>

              <v-layout row align-center v-if="selectedInvestor.payment_type === 'monthly'">

                <v-icon small color="teal darken-2" class="mr-2">fas fa-tasks</v-icon>

                <div>

                  <p class="caption grey--text mb-0">Months Completed</p>

                  <p class="body-2 font-weight-bold mb-0">{{ selectedInvestor.completed_payments }} / 10</p>

                </div>

              </v-layout>

            </v-flex>

          </v-layout>



          <!-- Monthly Payment Timeline -->

          <div v-if="selectedInvestor.payment_type === 'monthly' && selectedInvestor.payments && selectedInvestor.payments.length > 0">

            <v-divider class="mb-3"></v-divider>

            <div class="section-label mb-3">

              <v-icon small color="teal darken-2" class="mr-1">fas fa-calendar-check</v-icon>

              Payment Timeline — Validated Payments

            </div>

            <v-layout row wrap>

              <v-flex

                v-for="payment in selectedInvestor.payments"

                :key="payment.month_number"

                xs6 sm3

                class="pa-2"

              >

                <div class="timeline-detail-card" :class="'tdc--' + getPaymentStatusColor(payment.status)">

                  <v-chip small :color="getPaymentStatusColor(payment.status)" dark class="mb-2">

                    <v-icon x-small left>{{ getPaymentStatusIcon(payment.status) }}</v-icon>

                    Month {{ payment.month_number }}

                  </v-chip>

                  <p class="caption grey--text mb-1">Amount Paid</p>

                  <p class="body-2 font-weight-bold green--text mb-1">{{ formatAmount(payment.amount_paid) }} FCFA</p>

                  <p class="caption grey--text mb-0">{{ formatDate(payment.payment_date) }}</p>

                </div>

              </v-flex>

            </v-layout>

          </div>



          <!-- One-time status -->

          <div v-if="selectedInvestor.payment_type === 'one_time'">

            <v-divider class="mb-3"></v-divider>

            <v-alert

              :type="selectedInvestor.one_time_payment_made ? 'success' : 'info'"

              border="left"

              colored-border

              elevation="2"

              :value="true"

            >

              <v-layout row wrap align-center>

                <v-flex xs2 class="text-xs-center">

                  <v-icon size="40" :color="selectedInvestor.one_time_payment_made ? 'green' : 'grey'">

                    {{ selectedInvestor.one_time_payment_made ? 'fas fa-check-circle' : 'fas fa-clock' }}

                  </v-icon>

                </v-flex>

                <v-flex xs10>

                  <h4 class="subtitle-1 font-weight-bold mb-1">One-Time Payment Status</h4>

                  <p class="body-2 mb-0">

                    {{ selectedInvestor.one_time_payment_made ? 'Payment completed successfully.' : 'Payment still pending.' }}

                  </p>

                </v-flex>

              </v-layout>

            </v-alert>

          </div>



        </v-card-text>



        <v-card-actions class="pa-4" style="background: #fafafa; border-top: 1px solid #eceff1;">

          <v-spacer></v-spacer>

          <v-btn flat color="grey darken-1" @click="detailsDialog = false">

            <v-icon left small>fas fa-times</v-icon>

            Close

          </v-btn>

        </v-card-actions>

      </v-card>

    </v-dialog>



  </div>

</template>



<script>

import axios from 'axios'



export default {

  data() {

    return {

      // Access control

      hasActiveInvestment: null, // null=loading | false=no access | true=ok



      // Page data — field names copied exactly from /api/v1/savings/investments/all-investors/

      investors: [],          // each item: investment_id, username, full_name, payment_type,

                              //   investment_amount, total_paid, interest_earned,

                              //   completed_payments, progress_percentage, end_date, start_date,

                              //   payments[], one_time_payment_made

      globalStats: {          // from response.data.global_stats

        total_invested: 0,

        total_paid: 0,

        total_interest: 0,

        avg_progress: 0

      },



      // UI

      tabs: null,

      tabsItems: [],

      searchQuery: '',

      filterPaymentType: 'all',

      sortBy: 'progress_desc',

      isLoading: false,

      detailsDialog: false,

      selectedInvestor: null,



      paymentTypeOptions: [

        { text: 'All Types',           value: 'all' },

        { text: 'Monthly Payment',     value: 'monthly' },

        { text: 'One-Time Payment',    value: 'one_time' }

      ],



      sortOptions: [

        { text: 'Progress (High to Low)',      value: 'progress_desc' },

        { text: 'Progress (Low to High)',      value: 'progress_asc' },

        { text: 'Amount (High to Low)',        value: 'amount_desc' },

        { text: 'Amount (Low to High)',        value: 'amount_asc' },

        { text: 'Name (A–Z)',                  value: 'name_asc' },

        { text: 'Name (Z–A)',                  value: 'name_desc' }

      ]

    }

  },



  computed: {

    totalInvestors() {

      return this.investors.length

    },



    paymentTypeStats() {

      const monthly = this.investors.filter(i => i.payment_type === 'monthly').length

      const onetime = this.investors.filter(i => i.payment_type === 'one_time').length

      const total   = this.investors.length || 1

      return {

        monthly_count:       monthly,

        onetime_count:       onetime,

        monthly_percentage:  Math.round((monthly / total) * 100),

        onetime_percentage:  Math.round((onetime / total) * 100)

      }

    },



    progressStats() {

      return {

        high:   this.investors.filter(i => i.progress_percentage >= 80).length,

        medium: this.investors.filter(i => i.progress_percentage >= 50 && i.progress_percentage < 80).length,

        low:    this.investors.filter(i => i.progress_percentage < 50).length

      }

    },



    filteredInvestors() {

      let list = [...this.investors]



      if (this.searchQuery) {

        const q = this.searchQuery.toLowerCase()

        list = list.filter(i =>

          i.username.toLowerCase().includes(q) ||

          (i.full_name && i.full_name.toLowerCase().includes(q))

        )

      }



      if (this.filterPaymentType !== 'all') {

        list = list.filter(i => i.payment_type === this.filterPaymentType)

      }



      list.sort((a, b) => {

        switch (this.sortBy) {

          case 'progress_desc': return b.progress_percentage - a.progress_percentage

          case 'progress_asc':  return a.progress_percentage - b.progress_percentage

          case 'amount_desc':   return b.investment_amount - a.investment_amount

          case 'amount_asc':    return a.investment_amount - b.investment_amount

          case 'name_asc':      return a.username.localeCompare(b.username)

          case 'name_desc':     return b.username.localeCompare(a.username)

          default:              return 0

        }

      })



      return list

    }

  },



  methods: {

    // ── Access check ──────────────────────────────────────────────

    async checkAccess() {

      try {

        const response = await axios.get('/api/v1/savings/investments/list/')

        const investments = response.data.investments || []

        // Access granted only if at least one investment is active or completed

        // (pending_first_payment = no validated payment yet → denied)

        this.hasActiveInvestment = investments.some(

          inv => inv.status === 'active' || inv.status === 'completed'

        )

      } catch {

        this.hasActiveInvestment = false

      }

    },



    // ── Load investors ────────────────────────────────────────────

    async loadInvestors() {

      this.isLoading = true

      this.$store.commit('setIsLoading', true)

      try {

        const response = await axios.get('/api/v1/savings/investments/all-investors/')

        if (response.data.success) {

          this.investors   = response.data.investors

          this.globalStats = response.data.global_stats

        }

      } catch {

        this.$store.commit('setSnackBarMessage', 'Connection error. Check your internet.')

        this.$store.commit('setSnackBarColor', 'red darken-4')

        this.$store.commit('activateSnackBar', true)

      } finally {

        this.isLoading = false

        this.$store.commit('setIsLoading', false)

      }

    },



    openDetailsDialog(investor) {

      this.selectedInvestor = investor

      this.detailsDialog = true

    },



    // ── Formatters ────────────────────────────────────────────────

    formatAmount(value) {

      return new Intl.NumberFormat('fr-FR').format(value || 0)

    },



    formatDate(value) {

      if (!value) return '—'

      return new Date(value).toLocaleDateString('fr-FR', {

        day: '2-digit', month: '2-digit', year: 'numeric'

      })

    },



    // ── Display helpers ───────────────────────────────────────────

    getInitials(username) {

      return username ? username.substring(0, 2).toUpperCase() : '?'

    },



    getAvatarColor(username) {

      const colors = [

        'teal darken-2', 'blue darken-2', 'green darken-2', 'purple darken-2',

        'orange darken-2', 'pink darken-2', 'indigo darken-2', 'cyan darken-2'

      ]

      return colors[username.charCodeAt(0) % colors.length]

    },



    getAvatarRingClass(username) {

      const rings = [

        'ring-teal', 'ring-blue', 'ring-green', 'ring-purple',

        'ring-orange', 'ring-pink', 'ring-indigo', 'ring-cyan'

      ]

      return rings[username.charCodeAt(0) % rings.length]

    },



    getPaymentTypeColor(type) {

      return type === 'monthly' ? 'purple darken-2' : 'green darken-2'

    },



    getPaymentTypeIcon(type) {

      return type === 'monthly' ? 'fas fa-calendar-alt' : 'fas fa-hand-holding-usd'

    },



    getProgressColor(pct) {

      if (pct >= 80) return 'green darken-1'

      if (pct >= 50) return 'orange darken-1'

      return 'red darken-1'

    },



    getAccentClass(pct) {

      if (pct >= 80) return 'accent-green'

      if (pct >= 50) return 'accent-orange'

      return 'accent-red'

    },



    getPaymentStatusColor(status) {

      return { completed: 'green', partial: 'orange', pending: 'grey', failed: 'red' }[status] || 'grey'

    },



    getPaymentStatusIcon(status) {

      return {

        completed: 'fas fa-check',

        partial:   'fas fa-clock',

        pending:   'fas fa-hourglass-half',

        failed:    'fas fa-times'

      }[status] || 'fas fa-question'

    },



    getPaymentStatusLabel(status) {

      return { completed: 'Completed', partial: 'Partial', pending: 'Pending', failed: 'Failed' }[status] || status

    }

  },



  mounted() {

    this.checkAccess().then(() => {

      if (this.hasActiveInvestment) {

        this.loadInvestors()

      }

    })

    document.title = 'PettyCash | All Investors'

    this.$store.commit('setCloseURL', '/savings/investments')

  }

}

</script>



<style scoped>

/* ── Base ──────────────────────────────────────────────────── */

.page-root { background: #f0f4f8; min-height: 100vh; }



/* ── State screens ─────────────────────────────────────────── */

.state-screen {

  display: flex;

  flex-direction: column;

  align-items: center;

  justify-content: center;

  min-height: calc(100vh - 100px);

  padding: 24px;

}



/* Loader ring */

.loader-ring { display: inline-block; position: relative; width: 64px; height: 64px; }

.loader-ring div {

  box-sizing: border-box; display: block; position: absolute;

  width: 52px; height: 52px; margin: 6px;

  border: 6px solid #00897b; border-radius: 50%;

  animation: ring-spin 1.2s cubic-bezier(.5,0,.5,1) infinite;

  border-color: #00897b transparent transparent transparent;

}

.loader-ring div:nth-child(1) { animation-delay: -.45s; }

.loader-ring div:nth-child(2) { animation-delay: -.3s; }

.loader-ring div:nth-child(3) { animation-delay: -.15s; }

@keyframes ring-spin { 0% { transform: rotate(0); } 100% { transform: rotate(360deg); } }

.loader-label { color: #78909c; margin-top: 20px; font-size: 15px; letter-spacing: .5px; }



/* ── No-Access Gate ────────────────────────────────────────── */

.no-access-bg { background: linear-gradient(145deg, #e0f7fa 0%, #f3e5f5 100%); }



.gate-card {

  background: white;

  border-radius: 24px;

  padding: 48px 40px;

  max-width: 520px;

  width: 100%;

  box-shadow: 0 20px 60px rgba(0,0,0,.12);

  text-align: center;

}



.gate-icon-wrap {

  position: relative;

  display: inline-flex;

  align-items: center;

  justify-content: center;

  width: 96px; height: 96px;

  background: linear-gradient(135deg, #00897b, #00bcd4);

  border-radius: 50%;

  margin-bottom: 28px;

  box-shadow: 0 8px 32px rgba(0,137,123,.35);

}

.gate-pulse {

  position: absolute; inset: -8px;

  border-radius: 50%;

  border: 2px solid rgba(0,137,123,.3);

  animation: gate-pulse 2s ease-in-out infinite;

}

@keyframes gate-pulse {

  0%, 100% { transform: scale(1); opacity: .6; }

  50%       { transform: scale(1.12); opacity: .2; }

}



.gate-eyebrow {

  font-size: 11px; font-weight: 700;

  letter-spacing: 2px; text-transform: uppercase;

  color: #00897b; margin-bottom: 10px;

}

.gate-title {

  font-size: 28px; font-weight: 800;

  color: #1a2332; line-height: 1.25; margin-bottom: 16px;

}

.gate-body {

  font-size: 15px; color: #607d8b;

  line-height: 1.7; margin-bottom: 24px;

}

.gate-divider {

  width: 48px; height: 3px;

  background: linear-gradient(90deg, #00897b, #00bcd4);

  border-radius: 2px; margin: 0 auto 24px;

}

.gate-pitch { display: flex; flex-direction: column; gap: 10px; margin-bottom: 32px; }

.pitch-badge {

  display: flex; align-items: center; gap: 10px;

  background: #e0f7fa; border-radius: 10px;

  padding: 10px 16px; font-size: 14px;

  color: #37474f; font-weight: 500;

}

.gate-actions { display: flex; flex-direction: column; gap: 12px; }

.gate-btn-primary { border-radius: 14px !important; }

.gate-btn-ghost   { border-radius: 14px !important; }



/* ── Hero ──────────────────────────────────────────────────── */

.investors-overview-container { max-width: 1400px; margin: 0 auto; padding: 20px; }



.hero-header {

  background: linear-gradient(135deg, #00695c 0%, #004d40 60%, #1a237e 100%);

  border-radius: 20px;

  padding: 36px 32px;

  position: relative;

  overflow: hidden;

  box-shadow: 0 8px 32px rgba(0,100,80,.35);

}

.hero-glow {

  position: absolute; top: -60px; right: -60px;

  width: 280px; height: 280px; border-radius: 50%;

  background: radial-gradient(circle, rgba(0,188,212,.25) 0%, transparent 70%);

}

.hero-inner { position: relative; z-index: 1; }



.hero-eyebrow {

  display: flex; align-items: center; gap: 8px;

  color: rgba(255,255,255,.7);

  font-size: 12px; font-weight: 600;

  letter-spacing: 1.5px; text-transform: uppercase;

  margin-bottom: 12px;

}

.eyebrow-dot {

  width: 8px; height: 8px; border-radius: 50%;

  background: #00e5ff; box-shadow: 0 0 8px #00e5ff;

  animation: dot-blink 2s ease-in-out infinite;

  flex-shrink: 0;

}

@keyframes dot-blink { 0%,100%{opacity:1} 50%{opacity:.3} }



.hero-title {

  font-size: 40px; font-weight: 900;

  color: white; line-height: 1.1;

  margin-bottom: 10px; letter-spacing: -1px;

}

.hero-sub { color: rgba(255,255,255,.65); font-size: 16px; margin: 0; }



.hero-kpi-row {

  display: flex; align-items: center;

  background: rgba(255,255,255,.1);

  border-radius: 16px; padding: 20px 24px;

  border: 1px solid rgba(255,255,255,.15);

}

.hero-kpi         { text-align: center; padding: 0 20px; flex: 1; }

.hero-kpi-sep     { width: 1px; height: 48px; background: rgba(255,255,255,.2); flex-shrink: 0; }

.kpi-number       { display: block; font-size: 30px; font-weight: 900; color: white; line-height: 1; }

.kpi-label        { display: block; font-size: 11px; color: rgba(255,255,255,.6); line-height: 1.4; margin-top: 4px; }



/* ── Stats section ─────────────────────────────────────────── */

.section-label {

  font-size: 12px; font-weight: 700;

  color: #546e7a; text-transform: uppercase; letter-spacing: 1px;

}

.chart-title { font-size: 14px; font-weight: 600; color: #455a64; }



.dist-meta { display: flex; align-items: center; }

.dist-name  { font-size: 13px; font-weight: 600; color: #37474f; flex: 1; margin: 0 8px; }

.dist-count { font-size: 13px; font-weight: 700; color: #00897b; }

.dist-track { background: #eceff1; border-radius: 8px; height: 36px; overflow: hidden; }

.dist-fill  {

  height: 100%; border-radius: 8px;

  display: flex; align-items: center; justify-content: flex-end;

  padding-right: 10px; min-width: 40px;

  transition: width .8s cubic-bezier(.4,0,.2,1);

}

.monthly-fill { background: linear-gradient(90deg, #7b1fa2, #ab47bc); }

.onetime-fill { background: linear-gradient(90deg, #2e7d32, #66bb6a); }

.dist-pct     { color: white; font-size: 12px; font-weight: 700; }



.prog-range {

  font-size: 11px; font-weight: 700;

  padding: 2px 8px; border-radius: 6px; display: inline-block;

}

.high-range { background: #e8f5e9; color: #2e7d32; }

.mid-range  { background: #fff3e0; color: #e65100; }

.low-range  { background: #ffebee; color: #c62828; }



/* ── Filters ───────────────────────────────────────────────── */

.result-meta { font-size: 13px; color: #78909c; padding: 0 4px; }



/* ── Investor cards ────────────────────────────────────────── */

.investor-card {

  position: relative;

  transition: transform .25s ease, box-shadow .25s ease;

}

.investor-card:hover {

  transform: translateY(-3px);

  box-shadow: 0 12px 32px rgba(0,0,0,.14) !important;

}

.accent-bar {

  position: absolute; left: 0; top: 0; bottom: 0; width: 5px;

}

.accent-green  { background: linear-gradient(180deg, #43a047, #1b5e20); }

.accent-orange { background: linear-gradient(180deg, #fb8c00, #bf360c); }

.accent-red    { background: linear-gradient(180deg, #e53935, #880e4f); }



.avatar-ring { border-radius: 50%; padding: 3px; flex-shrink: 0; }

.ring-teal   { background: linear-gradient(135deg, #00897b, #80cbc4); }

.ring-blue   { background: linear-gradient(135deg, #1976d2, #90caf9); }

.ring-green  { background: linear-gradient(135deg, #388e3c, #a5d6a7); }

.ring-purple { background: linear-gradient(135deg, #7b1fa2, #ce93d8); }

.ring-orange { background: linear-gradient(135deg, #f57c00, #ffcc80); }

.ring-pink   { background: linear-gradient(135deg, #c2185b, #f48fb1); }

.ring-indigo { background: linear-gradient(135deg, #303f9f, #9fa8da); }

.ring-cyan   { background: linear-gradient(135deg, #0097a7, #80deea); }



.investor-name   { font-size: 15px; font-weight: 700; color: #1a2332; }

.investor-handle { font-size: 12px; color: #90a4ae; }



.stat-pill       { background: #f5f7fa; border-radius: 10px; padding: 8px 10px; text-align: center; }

.stat-pill-label { display: block; font-size: 10px; color: #90a4ae; font-weight: 600; text-transform: uppercase; letter-spacing: .5px; margin-bottom: 3px; }

.stat-pill-value { display: block; font-size: 13px; font-weight: 700; color: #37474f; }

.stat-pill-value small { font-size: 10px; color: #90a4ae; font-weight: 600; }



/* ── Skeleton ──────────────────────────────────────────────── */

.skeleton-card {

  height: 120px; border-radius: 14px;

  background: linear-gradient(90deg, #eceff1 25%, #e0e7ea 50%, #eceff1 75%);

  background-size: 200% 100%;

  animation: skeleton-wave 1.5s infinite;

}

@keyframes skeleton-wave {

  0%   { background-position: 200% 0; }

  100% { background-position: -200% 0; }

}



/* ── Dialog ────────────────────────────────────────────────── */

.dialog-hero { position: relative; overflow: hidden; }

.dialog-hero--purple { background: linear-gradient(135deg, #7b1fa2 0%, #4a148c 100%); }

.dialog-hero--green  { background: linear-gradient(135deg, #00897b 0%, #004d40 100%); }



.dialog-kpi          { padding: 18px; border-radius: 14px; text-align: center; }

.teal-kpi            { background: #e0f2f1; }

.green-kpi           { background: #e8f5e9; }

.purple-kpi          { background: #f3e5f5; }



.timeline-detail-card {

  background: #fafafa; border-radius: 10px;

  padding: 12px; text-align: center;

  border-left: 4px solid transparent;

}

.tdc--green  { border-left-color: #43a047; }

.tdc--orange { border-left-color: #fb8c00; }

.tdc--grey   { border-left-color: #90a4ae; }

.tdc--red    { border-left-color: #e53935; }



/* ── Responsive ────────────────────────────────────────────── */

@media (max-width: 600px) {

  .hero-title  { font-size: 26px; }

  .hero-header { padding: 24px 16px; }

  .gate-card   { padding: 32px 20px; }

  .gate-title  { font-size: 22px; }

  .hero-kpi-row { flex-wrap: wrap; }

  .hero-kpi    { padding: 8px; }

  .investors-overview-container { padding: 10px; }

}

</style>